import React from "react";

const MATRIX_ITEMS = [
    {
        key: "critical",
        title: "CRITICAL Severity & Extremely High Impact",
        description:
            "Requires immediate action. Affects account standing, active listing buyability, or major pricing/token errors.",
    },
    {
        key: "high",
        title: "HIGH Severity & Very High / High Impact",
        description:
            "Important business impact such as Buy Box loss or severe FBA inventory drops, and should be reviewed quickly.",
    },
    {
        key: "medium",
        title: "MEDIUM Severity & Medium Impact",
        description:
            "Requires review but generally not immediately blocking (e.g., MFN quantity shifts or minor content overwrites).",
    },
    {
        key: "low",
        title: "LOW Severity & Low Impact",
        description:
            "Informational or low immediate business impact (e.g., product classification shifts or normal account verifications).",
    },
];

function ClassificationMatrixOverview() {
    return (
        <div className="anm-matrix-overview">
            {MATRIX_ITEMS.map((item) => (
                <div
                    key={item.key}
                    className={`anm-matrix-card anm-matrix-card--${item.key}`}
                >
                    <div className="anm-matrix-title">{item.title}</div>
                    <div className="anm-matrix-description">{item.description}</div>
                </div>
            ))}
        </div>
    );
}

export default ClassificationMatrixOverview;
